import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from 'app/core/i18n/translate.pipe';
import { BPGroupedItem } from '../../types/bp-grouping.types';

@Component({
  selector: 'app-group-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule, TranslatePipe],
  template: `
    <div class="group-card" (click)="onOpenDetail()">
      <div class="group-info">
        <!-- Code & Count Badge Row -->
        <div class="mb-1 flex items-center gap-2">
          <span class="font-mono text-xs text-primary">{{ group().code }}</span>
          <span class="count-badge">{{ 'routing.SUB_ROUTE_PARTNERS.GROUP_CARD.COUNT' | t: { count: group().totalBusinessPartners } }}</span>
        </div>

        <!-- Name -->
        <div class="group-name">{{ group().name }}</div>
      </div>

      <!-- View Detail Action -->
      <button
        mat-icon-button
        color="primary"
        (click)="onOpenDetail(); $event.stopPropagation()"
        [matTooltip]="'routing.SUB_ROUTE_PARTNERS.GROUP_CARD.VIEW_TOOLTIP' | t"
        class="!h-8 !w-8 flex-shrink-0"
      >
        <mat-icon class="!text-lg">visibility</mat-icon>
      </button>
    </div>
  `,
  styles: `
    .group-card {
      padding: 0.75rem;
      margin-bottom: 0.5rem;
      border-radius: 0.5rem;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0.5rem;
      background: rgba(var(--fuse-bg-card-rgb), 1);
      border: 1px solid rgba(var(--fuse-border-rgb), 0.12);

      &:hover {
        background: rgba(var(--fuse-primary-rgb), 0.04);
        border-color: rgba(var(--fuse-primary-rgb), 0.2);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }
    }

    .group-info {
      flex: 1;
      min-width: 0;
    }

    .group-name {
      font-weight: 600;
      font-size: 0.875rem;
      color: rgba(var(--fuse-text-default-rgb), 1);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .count-badge {
      font-size: 0.625rem;
      padding: 0.125rem 0.5rem;
      border-radius: 9999px;
      background: rgba(245, 158, 11, 0.12);
      color: rgb(180, 83, 9);
      font-weight: 600;
      white-space: nowrap;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupCardComponent {
  group = input.required<BPGroupedItem>();
  openDetail = output<BPGroupedItem>();

  onOpenDetail(): void {
    this.openDetail.emit(this.group());
  }
}
